var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.894 13.334a.75.75 0 0 0-.75-.187A8.258 8.258 0 0 1 10.851 2.853a.75.75 0 0 0-.938-.938 9.83 9.83 0 0 0-4.96 3.47A9.75 9.75 0 0 0 12.75 21a9.66 9.66 0 0 0 5.861-1.957 9.83 9.83 0 0 0 3.469-4.96.75.75 0 0 0-.186-.749m-4.185 4.51A8.25 8.25 0 0 1 6.156 6.292a8.34 8.34 0 0 1 2.943-2.438 9.76 9.76 0 0 0 11.05 11.047 8.34 8.34 0 0 1-2.44 2.943"
  })));
};
export default SvgMoon;